import cx from 'classnames'

export default ({ children, className = '' }) => (
  children.length ?
    <div className={ cx('dropdown-group-item', className) }>{ children }</div> :
    <div className={ cx('dropdown-group-item', 'is__empty', className) } />
)
